import { render, staticRenderFns } from "./SinglePspMethod.vue?vue&type=template&id=0c8422aa&scoped=true"
import script from "./SinglePspMethod.vue?vue&type=script&lang=js"
export * from "./SinglePspMethod.vue?vue&type=script&lang=js"
import style0 from "./SinglePspMethod.vue?vue&type=style&index=0&id=0c8422aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8422aa",
  null
  
)

export default component.exports